import { useParams, useHistory, Switch, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { SUBPAGES, SUBROUTES } from './routes';
import FieldService from 'services/FieldService';
import { useAsync } from 'react-use';
import Loader from 'components/Kizen/Loader';
import { useSetTitleOnLoad } from 'hooks/useSetTitleOnLoad';
import { setRecordTitle } from 'pages/CustomObjects/RecordsPage';
import { useBreakpoint } from 'app/spacing';
import { Nav } from 'components/Navigation/NavLayout';
import { useSelector } from 'react-redux';
import { getBusinessClientObject } from 'store/authentication/selectors';

export const FilterGroupsPage = ({ title }) => {
  const { t } = useTranslation();
  const { objectId, subpage } = useParams();
  const history = useHistory();

  const clientObject = useSelector(getBusinessClientObject);

  const { value: model, loading: loadingModel } = useAsync(async () => {
    return FieldService.getModel({ id: objectId || clientObject.id });
  }, [objectId]);

  useSetTitleOnLoad(setRecordTitle(title(t), objectId ? model : {}));

  useEffect(() => {
    if (!subpage || !Object.values(SUBPAGES).includes(subpage)) {
      history.replace(history.location.pathname + '/' + SUBPAGES.MINE);
    }
  }, [history, subpage]);

  const isMobile = useBreakpoint();

  return (
    <>
      <Nav.Container>
        <Nav.SubNavigationRow>
          {Object.entries(SUBROUTES).map(([key, route], index, arr) => {
            return (
              <Nav.SubNavigationLink
                key={key}
                isLast={index === arr.length - 1}
                route={route}
                to={route.path}
                isActive={() => subpage === route.path}
              />
            );
          })}
        </Nav.SubNavigationRow>
      </Nav.Container>
      <Loader loading={loadingModel}>
        <Switch>
          {Object.entries(SUBROUTES).map(([key, route]) => {
            const Component = route.component;
            return (
              <Route
                key={key}
                path={'*/filter-groups/' + route.path}
                exact={route.exact !== false}
              >
                <Component
                  isMobile={isMobile}
                  objectId={objectId}
                  model={model}
                />
              </Route>
            );
          })}
        </Switch>
      </Loader>
    </>
  );
};
